import './index.scss'

const Loader = () => {
	return (
			<div class="loader">
				<div class="dot">.</div>
				<div class="slash">/</div>
				<div class="star">*</div>
			</div>
	);
}

export default Loader
